import { gql } from '../../../__generated__/graphql/catalog'

export const FETCH_CART = gql(`
  query fetchCart($cartId: String!) {
    cart(cartId: $cartId) {
      cart {
        ...Cart
      }
    }
  }
`)

export const FETCH_CART_EXISTS = gql(`
  query fetchCartExists($cartId: String!) {
    cart(cartId: $cartId) {
      cart {
        id
      }
    }
  }
`)
